import { noUser } from '@ils/permissions/roles/noUser.js';
import type { RolesWithPermissions } from '../permissions.js';
import { accounting } from './accounting.js';
import { actor } from './actor.js';
import { admin } from './admin.js';
import { candidate } from './candidate.js';
import { digifort } from './digifort.js';
import { examCenter } from './examCenter.js';
import { examCenterManager } from './examCenterManager.js';
import { inspector } from './inspector.js';
import { resolveErrors } from './resolveErrors.js';
import { support } from './support.js';

export const permissions: RolesWithPermissions = {
  admin,
  accounting,
  actor,
  candidate,
  digifort,
  examCenter,
  examCenterManager,
  inspector,
  resolveErrors,
  support,
  noUser,
};
